import { BaseComponent } from './shared/components/base.component';
import { DataSource } from '@angular/cdk/table';
import { Component, HostListener, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { envSettings } from '../common/constant';
// import { GlobalSettings } from '../config/global-settings';
import { MediaMatcher, BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, OnDestroy } from '@angular/core';
import { routeSlider } from './route-animations';
import { RouterOutlet, Router, Event, NavigationStart, RoutesRecognized, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import { InfiniteScrollDirective } from './shared/directives/infinite-scroll.directive';
import { AppService } from 'src/core/services/app-service';
import { filter, map, switchMap, takeUntil, take } from 'rxjs/operators';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { MAT_MOMENT_DATE_FORMATS, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { CdkScrollable } from '@angular/cdk/overlay';
import { UserIdleService } from 'angular-user-idle';
import { DialogAvatarComponent } from './shared/components/dialog-avatar/dialog-avatar.component';
import { DialogChangeInstanceComponent } from './shared/components/dialog-change-instance/dialog-change-instance.component';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { PrintHook, MediaMarshaller } from '@angular/flex-layout';


// https://material.angular.io/components/datepicker/overview#choosing-a-date-implementation-and-date-format-settings
export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-root',
  providers: [
    // GlobalSettings,
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    // https://material.angular.io/components/datepicker/overview#choosing-a-date-implementation-and-date-format-settings
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },  // MAT_MOMENT_DATE_FORMATS
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // styles: ['@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.2/css/all.min.css";'],
  animations: [
    routeSlider
  ]
})

export class AppComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

  public enviOptions = envSettings;
  public appEnvironment = environment;
  // private _mobileQueryListener: () => void;
  // headers: Headers;
  // public menus: any[];
  // mobileQuery: MediaQueryList;
  // opened: boolean = true;
  public isMobileViewportYN = false;
  // mobileMediaQuery = '(max-width: 599px)';
  public toggleThemerPanel = false;

  previousRoute = '';

  // @ViewChild(InfiniteScrollDirective, {static: true}) infiniteScrollElem;
  @ViewChild('snavLeft', {static: true}) public snavLeft: MatSidenav;
  // @ViewChild('snavRight', {static: true}) public snavRight: MatSidenav;
  // @ViewChild(CdkScrollable, {static: true}) scrollable: CdkScrollable;


  constructor(
    public appService: AppService,
    // private globalSettings: GlobalSettings,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public authenticationService: AuthenticationService,
    // changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    public breakpointObserver: BreakpointObserver,
    private userIdle: UserIdleService,
    private dialog: MatDialog,
    private titleService: Title,
    // private readonly printHook: PrintHook,
    private mediaMarshaller: MediaMarshaller,
  ) {
    super(authenticationService);
    // this.enviOptions.toggleView = false;
    // this.mobileQuery = media.matchMedia('(max-width: 599px)');
    // this._mobileQueryListener = () => {
    //   changeDetectorRef.detectChanges();
    //   // if (this.mobileQuery.matches) {
    //   //   this.enviOptions.leftPanelYN = false;
    //   // } else {
    //   //   this.enviOptions.leftPanelYN = true;
    //   // }
    // };
    // this.mobileQuery.addListener(this._mobileQueryListener);

    // detect media query change (here mobile viewport)
    this.breakpointObserver
      .observe([/*this.mobileMediaQuery,*/ Breakpoints.XSmall]) // https://github.com/angular/components/blob/master/src/cdk/layout/breakpoints.ts
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe((state: BreakpointState) => {
        // console.log('IsMobile', state.matches);
        this.isMobileViewportYN = state.matches;
        this.enviOptions.leftPanelYN = !this.isMobileViewportYN;
    });

    // document.body.classList.add('fp-green');
    this.monitorRouteChanges(router);
    // this.router.events
    // .pipe(
    //  filter(event => event instanceof NavigationEnd),
    //  map(() => this.activatedRoute),
    //  map(route => route.firstChild))
    //  // switchMap(route => route.data),
    //  // map(data => data['depth']))
    //  .subscribe( (data) => {
    //    console.log(data);
    //  });

    this.titleService.setTitle(this.appEnvironment.appDisplayName);


    // // Temp Hack: https://github.com/angular/flex-layout/issues/1228
    // const printHookAny = this.printHook as any;
    // const orig = printHookAny.collectActivations;
    // printHookAny.collectActivations = (event) => {
    //   // console.log('isPrintingBeforeAfterEvent', printHookAny.isPrintingBeforeAfterEvent);
    //   if (!printHookAny.isPrintingBeforeAfterEvent) {
    //     orig.bind(printHookAny, event)();
    //   }
    // };

    // Temp hack until resolve: https://github.com/angular/flex-layout/issues/1201
    // @ts-ignore
    mediaMarshaller.subject.subscribe((x) => {
      // @ts-ignore
      if (mediaMarshaller.activatedBreakpoints.filter((b) => b.alias === 'print').length === 0) {
        // @ts-ignore
        this.lastValue = [...mediaMarshaller.activatedBreakpoints];
      } else {
        // @ts-ignore
        mediaMarshaller.activatedBreakpoints = [...this.lastValue];
        // @ts-ignore
        mediaMarshaller.hook.collectActivations = () => {};
        // @ts-ignore
        mediaMarshaller.hook.deactivations = [...this.lastValue];
      }
    });

  }


  ngOnInit(): void {
    // this.infiniteScrollElem.scrollEnding$.subscribe((data) => {
    //   console.log('infiniteScroll tick');
    //   console.log(data);
    // });
    // setTimeout(() => {
    //   this.snavLeft.close();
    //   this.snavRight.open();
    // });
    this.enviOptions.leftPanelYN = false;
    this.isMobileViewportYN = this.breakpointObserver.isMatched(Breakpoints.XSmall); // this.media.matchMedia(this.mobileMediaQuery).matches;
    // this.enviOptions.leftPanelYN = !this.isMobileViewportYN;

    if (this.userIsLoggedIn) {
      this.appService.setLeftMenuItems(this.authenticationService.userInfo.Menu);
    }


    // ---------
    // User Idle
    // ---------
    // Start watching for user inactivity.
    // this.userIdle.startWatching();
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
      // console.log(count);
    });
    // Start watch when time is up.
    this.userIdle.onTimeout().subscribe(() => {
      this.authenticationService.logout();
      // location.reload(true);
      this.dialog.closeAll();
      // this.router.navigate(['login']);
      this.router.navigate([environment.loginPagePath]);
    });
    // this.userIdle.stopTimer(); // it is the login page that is activating the timer
    // ---------
  }


  ngAfterViewInit(): void {
    // setTimeout(() => {
    //   this.snavLeft.close();
    //   this.snavRight.open();
    // });
    // setTimeout(() => {
    //   if (this.mobileQuery.matches) {
    //     this.snavLeft.close();
    //     console.log('azerty');
    //   }
    // }, 1000);
    // if (this.mobileQuery.matches) {
    //   this.enviOptions.leftPanelYN = false;
    // }

    // this.scrollable.elementScrolled().subscribe(() => {
    //   console.log('scrolled!');
    // });
  }


  get userIsLoggedIn() { return this.authenticationService.isLoggedIn(); }
  set userIsLoggedIn(fake) { }


  monitorRouteChanges(router: Router) {
    router.events
    .pipe(takeUntil(this.unsubscribe))
    .subscribe( (event: Event) => {
      if (event instanceof NavigationStart) {
        // console.log('NavigationStart');
        this.appService.setBlockScrolling(false);   // Set to default value, used only for stacked sliding panel when editing for example
        this.appService.setIsLoading(false);

        // DO NOT DELETE!
        // // When we navigate to any route that is not a nested route of the previous route, we make the circular menu disapearing
        // // Ex: from '/encounters' to '/encounters/details', the menu remains in the DOM (same from '/encounters/details' to '/encounters').
        // // But from '/encounters' to '/home', the circular menu is removed from the DOM.
        // if (!this.previousRoute.startsWith(event.url) && !event.url.startsWith(this.previousRoute)) {
        //   this.appService.setCircularMenuItems([]);
        // }

        // // Navigation started.
        // console.log(event.url);
        // console.log(event);

        // // When user comes from a different website and calls a route that is not login page (don't think it could happen, as the login page should be the only one accessible without being logged-in in most cases).
        // if (this.previousRoute === '' && !event.url.startsWith('/login')) {
        //   this.enviOptions.headerToolbarYN = true;
        //   setTimeout(() => {
        //     this.enviOptions.leftPanelYN = true;
        //     this.enviOptions.rightPanelYN = false;
        //   }, 300);
        // } else

        // // When navigating from login to any route, we show the header toolbar and left menu
        // if (this.previousRoute && this.previousRoute.startsWith('/login')) {
        //   // setTimeout(() => {
        //     this.enviOptions.headerToolbarYN = true;
        //     setTimeout(() => {
        //       this.enviOptions.leftPanelYN = true;
        //       this.enviOptions.rightPanelYN = true;
        //     }, 300);
        //   // }, 0);
        // }


        // this.enviOptions.headerToolbarYN = true;
        // this.enviOptions.leftPanelYN = true;
        // this.enviOptions.rightPanelYN = true;

        // When navigating to login we hide the header toolbar, the left and right menus.
        if (event.url.startsWith('/' + environment.loginPagePath) || event.url.startsWith('/auth/')) {
          this.enviOptions.leftPanelYN = false;
          this.enviOptions.rightPanelYN = false;
          // console.log(this.enviOptions);
          // this.enviOptions.headerToolbarYN = false;
          setTimeout(() => {
            this.enviOptions.headerToolbarYN = false;
          }, (this.previousRoute === '' ? 0 : 300));
        } else {
          // When user comes from a different website and calls a route that is not login page (don't think it could happen, as the login page should be the only one accessible without being logged-in in most cases).
          if (this.previousRoute === ''
            // When navigating from login to any route, we show the header toolbar and left menu
            || this.previousRoute.startsWith('/' + environment.loginPagePath) || this.previousRoute.startsWith('/auth/')) {
              if (this.userIsLoggedIn) {
                setTimeout(() => {
                  this.enviOptions.headerToolbarYN = true;
                  this.enviOptions.leftPanelYN = !this.isMobileViewportYN; // By default 'Opened' all  time except on mobile view.
                  this.enviOptions.rightPanelYN = false;
                }, 300);
              }
          }
        }
        this.previousRoute = event.url;
      } else if (event instanceof RouteConfigLoadStart) {
        // https://stackoverflow.com/questions/42981136/show-activity-indicator-while-loading-a-lazy-loaded-module-in-angular-2
        // Before the Router lazyloads a route configuration.
        // this.appService.setIsLoading(true);
        this.appService.setLasyLoadingRoutePath(event.route.path);
      } else if (event instanceof RouteConfigLoadEnd) {
        // Route has been lazy loaded.
        // this.appService.setIsLoading(false);
        this.appService.setLasyLoadingRoutePath(null);
      } else if (event instanceof NavigationEnd) {
          // Navigation Ended Successfully.
          // console.log(event.url);

          // // When navigating to login we hide the header toolbar, the left and right menus.
          // if (event.url && event.url.startsWith('/login')) {
          //   this.enviOptions.leftPanelYN = false;
          //   this.enviOptions.rightPanelYN = false;
          //   setTimeout(() => {
          //     this.enviOptions.headerToolbarYN = false;
          //   }, this.previousRoute === '' ? 0 : 250);
          // }
          // this.previousRoute = event.url;
          this.appService.setLasyLoadingRoutePath(null);
      }
      // else if (event instanceof NavigationCancel) {
      //     // Navigation is canceled as the Route-Guard returned false during navigation.
      // }
      // else if (event instanceof NavigationError) {
      //     // Navigation fails due to an unexpected error.
      //       console.log(event.error);
      // }
    }
  );
}

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData /*&& outlet.activatedRouteData['animation']*/;
  }


  // helpEnable() {
  //   this.enviOptions.toggleHelp = !this.enviOptions.toggleHelp;
  // }


  // shortCutKeyEnable() {
  //   this.enviOptions.toggleShortCutKeyPanel = !this.enviOptions
  //     .toggleShortCutKeyPanel;
  // }


  setAsDefault() {}


  logout() {
    this.authenticationService.logout();
    // this.router.navigateByUrl('/login');
    this.router.navigateByUrl('/' + environment.loginPagePath);
  }

  messages() {
    this.router.navigateByUrl('/messages');
  }

  myAccount() {
    this.router.navigateByUrl('/my-account');
  }


  changeAvatarPopup() {
    const dialogRef = this.dialog.open(DialogAvatarComponent, {
      width: '1024px',
      maxWidth: 1024,
      maxHeight: '80vh',
      autoFocus: false,
      // data: { message: `This is test of modal popup for changing avatar`, button: DialogAvatarButton.OK }
    });

    dialogRef.afterClosed()
    .pipe(take(1) /*takeUntil(this.unsubscribe)*/)
    .subscribe(result => {
      if (result && result.event === 'Ok') {
        // console.log('Success!');
      }
    });
  }


  changeInstance() {
    const dialogRef = this.dialog.open(DialogChangeInstanceComponent, {
      minWidth: '350px',
      autoFocus: false,
    });

    dialogRef.afterClosed()
    .pipe(take(1) /*takeUntil(this.unsubscribe)*/)
    .subscribe(result => {
      console.log('CLOSE', result);
      if (result && result.event === 'Ok') {
        // console.log('Success!');
      }
    });
  }


  // toggleMainView(value) {
  //   this.enviOptions.toggleView = value;
  // }


  ngOnDestroy(): void {
    // this.mobileQuery.removeListener(this._mobileQueryListener);
  }


  toggleThemer($event) {
    this.toggleThemerPanel = $event;
  }


  changeSkin(value: string) {
    document.body.className = '';
    document.body.classList.add(value);
  }


  // openedChange(state) {
  //   alert(state);
  //   // alert(this.snavLeft.opened);
  // }

}

export const environmentSettings = {
  showMainMenu: false,
  toggleShortCutKeyPanel: false,
  toggleHelp: false
};
